module.exports = __webpack_public_path__ + "static/media/ico_fav.8b384baa.svg";